import { useState } from "react";
import { PerformanceService } from "../../application/services/performanceService";

const performanceService = new PerformanceService();

export const usePerformance = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [performanceData, setPerformanceData] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [availableRamData, setAvailableRamData] = useState(null);
  const [metricTotalData, setMetricTotalData] = useState(null);

  const getVmPerformance = async (vmId, startDate, endDate) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceService.getVmPerformance(vmId, startDate, endDate);
      if (result.success) {
        setPerformanceData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmPerformanceSummary = async (vmId, startDate, endDate) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceService.getVmPerformanceSummary(vmId, startDate, endDate);
      if (result.success) {
        setSummaryData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmAvailableRam = async (vmId, startDate, endDate) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceService.getVmAvailableRam(vmId, startDate, endDate);
      if (result.success) {
        setAvailableRamData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmMetricTotal = async (vmId, startDate, endDate, metricType) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceService.getVmMetricTotal(vmId, startDate, endDate, metricType);
      if (result.success) {
        setMetricTotalData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    getVmPerformance,
    getVmPerformanceSummary,
    getVmAvailableRam,
    getVmMetricTotal,
    performanceData,
    summaryData,
    availableRamData,
    metricTotalData,
    loading,
    error,
  };
};